var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ma-5 pb-16"},[_c('ProfileEdit'),_c('Security')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }